import { getExpiryDate } from './utils'

export const customFieldsInitialState = {
  customFields: [],
  customFieldsExp: null,
  customFieldTypes: [],
  customFieldTypesExp: null,
}

export const CUSTOM_FIELDS_ACTIONS = {
  SET_CUSTOM_FIELDS: 'SET_CUSTOM_FIELDS',
  SET_CUSTOM_FIELD_TYPES: 'SET_CUSTOM_FIELD_TYPES',
}

export const customFieldsActions = {
  [CUSTOM_FIELDS_ACTIONS.SET_CUSTOM_FIELDS]: (_, { customFields }) => {
    return { customFields, customFieldsExp: getExpiryDate() }
  },
  [CUSTOM_FIELDS_ACTIONS.SET_CUSTOM_FIELD_TYPES]: (_, { customFieldTypes }) => {
    return { customFieldTypes, customFieldTypesExp: getExpiryDate() }
  },
}
